import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

import {
  IMPORT_ORDER_STATUSES,
  IMPORT_ORDER_STATUS_NAMES,
} from '@config/constants';
import actions from '@/application/actions';
import { useThrottle } from '@hooks';
import { FromToDatePicker, PaginationBar } from '@components';
import { ImportOrderDetailModal } from '@components/Modal';
import styles from './styles.module.scss';

function ImportOrderList(props) {
  const {
    actions: { fetchImportOrders, fetchImportOrder, updateImportOrderFilter },
    state: {
      stock: {
        importOrders,
        filter: { importOrders: filter },
      },
    },
  } = props;

  const updatePage = useThrottle(
    (page) => updateImportOrderFilter({ page }),
    500,
  );

  const openModal = (id) => () =>
    fetchImportOrder({
      id,
      isOpenModal: true,
    });
  const handleSelectedStatusChange = useCallback((e) => {
    updateImportOrderFilter({
      status: e.target.value,
    });
  }, []);

  const handleDateChange = useCallback(
    (type) => (date) => {
      updateImportOrderFilter({
        [type]: date,
        page: 1,
      });
    },
    [],
  );

  const handleBothDateChange = useCallback((from, to) => {
    updateImportOrderFilter({
      from,
      to,
      page: 1,
    });
  }, []);

  useEffect(() => {
    fetchImportOrders(filter);
  }, [filter]);

  return (
    <>
      <h3 className={styles.heading}>Danh sách đơn nhập</h3>

      <div className={styles.filter}>
        <div className={styles.date}>
          <FromToDatePicker
            startDate={filter.from.value}
            endDate={filter.to.value}
            setStartDate={handleDateChange('from')}
            setEndDate={handleDateChange('to')}
            setBothDate={handleBothDateChange}
          />
        </div>

        <select
          className={styles.filterSelect}
          value={filter.status}
          onChange={handleSelectedStatusChange}
        >
          <option value={0}>Tình trạng đơn hàng</option>
          {Object.values(IMPORT_ORDER_STATUSES).map((statusId) => (
            <option value={statusId} key={statusId}>
              {IMPORT_ORDER_STATUS_NAMES[statusId]}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.table}>
        <div className={clsx(styles.tableHeader, styles.row)}>
          <div className={styles.tableHeaderItem}>Mã đơn</div>
          <div className={clsx(styles.tableHeaderItem, 'isPC')}>Ngày tạo</div>
          <div className={styles.tableHeaderItem}>Tình trạng</div>
          <div className={styles.tableHeaderItem}>Tổng tiền</div>
          <div className={clsx(styles.tableHeaderItem)}>Nhà cung cấp</div>
          <div className={clsx(styles.tableHeaderItem, 'isPC')}>Người tạo</div>
          <div className={styles.tableHeaderItem}>Hành động</div>
        </div>

        <div className={styles.tableBody}>
          {importOrders.list.map((item) => (
            <div
              key={item.id}
              className={clsx(
                styles.row,
                styles.tableBodyItem,
                styles[`status-${item.status}`],
              )}
            >
              <div className={styles.tableBodyItemText}>{item.id}</div>

              <div className={clsx(styles.tableBodyItemText, 'isPC')}>
                {item.createdAt.localDate}
              </div>

              <div className={clsx(styles.tableBodyItemText, 'capitalize')}>
                {item.displayStatus}
              </div>

              <div className={styles.tableBodyItemText}>
                {item.totalPrice.vnd}
              </div>

              <div className={clsx(styles.tableBodyItemText, 'capitalize')}>
                {item.supplier.name}
              </div>

              <div className={clsx(styles.tableBodyItemText, 'isPC')}>
                {item.pic.displayName}
              </div>

              <div className={styles.tableBodyItemText}>
                <button
                  to={`/stock-management/export-bill/${item.id}`}
                  onClick={openModal(item.id)}
                  className={styles.action}
                >
                  <i className={clsx(styles.icon, 'fas fa-eye')} />
                </button>
                {/* <i
                  className={clsx(styles.icon, 'fas fa-trash')}
                  onClick={handleRemoveBillClick(item.id)}
                /> */}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.pagination}>
        <PaginationBar
          totalPage={importOrders.totalPage}
          noPages={9}
          columnWidth={40}
          currentPage={filter.page}
          setCurrentPage={updatePage}
        />
      </div>

      <ImportOrderDetailModal />
    </>
  );
}

const mapStateToProps = ({ state }) => ({ state });

export default connect(mapStateToProps, actions)(ImportOrderList);
